import { render, staticRenderFns } from "./RewardsHistorySection.vue?vue&type=template&id=1fa0a6e5"
import script from "./RewardsHistorySection.vue?vue&type=script&lang=js"
export * from "./RewardsHistorySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports